export default "__VITE_ASSET__BesL3aqW__"